"use strict";

exports.__esModule = true;
exports.default = {
  id: 1,
  zIndex: 2000,
  stack: [],
  lockCount: 0,

  plusKey: function plusKey(key) {
    // eslint-disable-next-line
    return this[key]++;
  },

  get top() {
    return this.stack[this.stack.length - 1];
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tuniu/dpl-vui/lib/mixins/popup/context.js
// module id = 198
// module chunks = 22